/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/295/interface/api/cat_549
 */

import { message } from 'ant-design-vue'
import {
  ums_service_queryUserValue_get,
  ums_service_modifyPassword_post,
  ums_service_create_post,
  ums_service_createAddress_post,
  ums_service_deleteAddressById_get,
  ums_service_deleteUser_get,
  ums_service_level_getUserLevelList_post,
  ums_service_queryUserInfoList_post,
  ums_service_receiveOrder_post,
  ums_service_updateAddress_post,
  ums_service_updateUserInfo_post,
  ums_service_queryUserInfoInTime_post,
  ums_service_queryPageUserInfo_post,
  ums_service_queryAddress_post,
  ums_service_queryUserInfo_post,
  ums_service_queryUserNewsLetter_get,
  ums_service_level_list_get,
  ums_service_checkPermission_post,
  ums_service_queryAddressById_get,
  ums_service_queryUserIdByShopifyUserId_post,
  ums_service_queryUserIdByThirdUserId_post,
  ums_service_tag_getTagByUserId_get,
  ums_service_queryPageUserByLevel_post,
  ums_service_queryAppAndMixUserByEmail_get,
  ums_service_register_post,
  ums_service_updateAddressUnDefaultByUserId_get,
  ums_service_login_post,
  ums_service_userNewsLetter_post,
  ums_service_quickRegister_post,
  ums_service_userSubOrUnsubscribe_post,
  ums_service_queryUserStatus_post,
  ums_service_queryUserIdByShopifyId_post,
  user_group_list_post,
  user_group_check_post,
  ums_service_marketing_queryBatchUserSubStatus_post,
  ums_service_userRights_queryUserFreeShippingRights_post,
  ums_service_queryUserIdByEmail_post,
  ums_service_queryAllUserIdByEmail_post,
  ums_service_userFirstSubscribe_post,
  ums_service_queryAllSiteUserIdByEmail_post,
  ums_service_queryUserByEmailTerminal_get,
  ums_service_sendVerifyCode_post,
  ums_service_smsSubscribe_post,
  ums_service_batchQueryLangCode_post,
  ums_service_queryAllPreferences_post,
  ums_service_addUserPreference_post,
  ums_service_queryAllMeasurements_post,
  ums_service_addUserMeasurement_post,
  ums_service_queryAllChooses_get,
  ums_service_addUserChoose_post,
  sps_service_checkContactIdentify_post,
  ums_service_user_level_get,
  ums_service_user_group_defined_check_post
} from 'server/modules/549'

// 查询用户价值
export const ums_service_queryUserValue_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryUserValue_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 修改密码
export const ums_service_modifyPassword_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_modifyPassword_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 创建用户-自建站使用
export const ums_service_create_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_create_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 创建用户地址
export const ums_service_createAddress_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_createAddress_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除地址
export const ums_service_deleteAddressById_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_deleteAddressById_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 删除用户
export const ums_service_deleteUser_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_deleteUser_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 外部接口-根据userIds 查询等级levelCode
export const ums_service_level_getUserLevelList_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_level_getUserLevelList_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 批量查询用户
export const ums_service_queryUserInfoList_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryUserInfoList_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 接受订单
export const ums_service_receiveOrder_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_receiveOrder_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 更新用户地址
export const ums_service_updateAddress_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_updateAddress_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 更新用户基础信息
export const ums_service_updateUserInfo_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_updateUserInfo_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询指定时间范围内变化的用户信息
export const ums_service_queryUserInfoInTime_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryUserInfoInTime_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询用户信息(积分使用)
export const ums_service_queryPageUserInfo_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryPageUserInfo_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询用户地址
export const ums_service_queryAddress_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryAddress_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询用户基础信息
export const ums_service_queryUserInfo_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryUserInfo_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询用户订阅信息
export const ums_service_queryUserNewsLetter_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryUserNewsLetter_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询等级列表
export const ums_service_level_list_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_level_list_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 校验账号是否存在
export const ums_service_checkPermission_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_checkPermission_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据id查询用户地址信息
export const ums_service_queryAddressById_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryAddressById_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据shopify用户id查询中台用户id
export const ums_service_queryUserIdByShopifyUserId_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryUserIdByShopifyUserId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据三方id查询用户id(OMS)
export const ums_service_queryUserIdByThirdUserId_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryUserIdByThirdUserId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据用户ID查询标签
export const ums_service_tag_getTagByUserId_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_tag_getTagByUserId_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据等级分页查询用户
export const ums_service_queryPageUserByLevel_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryPageUserByLevel_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据邮箱查询App和融合用户
export const ums_service_queryAppAndMixUserByEmail_get_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryAppAndMixUserByEmail_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 注册用户
export const ums_service_register_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_register_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 用户地址全部改为非默认地址
export const ums_service_updateAddressUnDefaultByUserId_get_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_updateAddressUnDefaultByUserId_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 用户登录(包含三方登录)
export const ums_service_login_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_login_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 用户订阅/取消订阅--要使用该接口必须先和用户中台开发沟通
export const ums_service_userNewsLetter_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_userNewsLetter_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 快速注册用户
export const ums_service_quickRegister_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_quickRegister_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 用户订阅、取消 - 即时
export const ums_service_userSubOrUnsubscribe_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_userSubOrUnsubscribe_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据邮箱、站点查询用户状态
export const ums_service_queryUserStatus_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryUserStatus_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据shopifyId查询userId
export const ums_service_queryUserIdByShopifyId_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryUserIdByShopifyId_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询可用的用户群
export const user_group_list_post_ = async function(params) {
  const { success, data, retInfo } = await user_group_list_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询用户是否与对应群组匹配
export const user_group_check_post_ = async function(params) {
  const { success, data, retInfo } = await user_group_check_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 批量查询邮件的订阅状态
export const ums_service_marketing_queryBatchUserSubStatus_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_marketing_queryBatchUserSubStatus_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询用户免邮权益
export const ums_service_userRights_queryUserFreeShippingRights_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_userRights_queryUserFreeShippingRights_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据邮箱查询一条userId，优先返回注册来源为shopify
export const ums_service_queryUserIdByEmail_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryUserIdByEmail_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据邮箱查询userId
export const ums_service_queryAllUserIdByEmail_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryAllUserIdByEmail_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 用户首次订阅
export const ums_service_userFirstSubscribe_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_userFirstSubscribe_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据邮箱查询所有站点的userId 列表
export const ums_service_queryAllSiteUserIdByEmail_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryAllSiteUserIdByEmail_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 根据邮箱和终端查询用户信息
export const ums_service_queryUserByEmailTerminal_get_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryUserByEmailTerminal_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 发送验证码
export const ums_service_sendVerifyCode_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_sendVerifyCode_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 用户手机号订阅
export const ums_service_smsSubscribe_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_smsSubscribe_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 批量查询用户常用语言编码
export const ums_service_batchQueryLangCode_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_batchQueryLangCode_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询偏好问答列表
export const ums_service_queryAllPreferences_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryAllPreferences_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 新增用户偏好选择
export const ums_service_addUserPreference_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_addUserPreference_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询尺寸问答列表
export const ums_service_queryAllMeasurements_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_queryAllMeasurements_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 新增用户尺寸选择
export const ums_service_addUserMeasurement_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_addUserMeasurement_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询取消订阅供用户选择的问答列表
export const ums_service_queryAllChooses_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_queryAllChooses_get(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 新增用户实际选择的答案
export const ums_service_addUserChoose_post_ = async function(params) {
  const { success, data, retInfo } = await ums_service_addUserChoose_post(
    params
  )
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 校验Emarsys传参中的用户id
export const sps_service_checkContactIdentify_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await sps_service_checkContactIdentify_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 获取用户等级
export const ums_service_user_level_get_ = async function(params) {
  const { success, data, retInfo } = await ums_service_user_level_get(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}

// 查询用户是否与自定义的用户群组匹配
export const ums_service_user_group_defined_check_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await ums_service_user_group_defined_check_post(params)
  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
